// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import { excludeGraphQLFetch } from 'apollo-link-sentry';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn: SENTRY_DSN || 'https://091624299ef44cd9b2d4618c735eb508@o1157255.ingest.sentry.io/6239564',
  environment: process.env.NEXT_PUBLIC_ENV_NAME || process.env.NODE_ENV,
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampler: (samplingContext) => {
    const { name, status } = samplingContext.transactionContext || {};
    if ((name || '').includes('error') || (status || '').includes('error')) {
      return 1;
    }
    if ((samplingContext.request?.headers?.host || '').includes('localhost')) {
      return 0;
    }
    // Default sample rate
    return 0.01;
  },
  beforeBreadcrumb: excludeGraphQLFetch,
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
});
